<template>
  <div class="legacy-preview mb-1">
    <img v-if="!!imgSrc" :src="imgSrc" />
    <danger v-else-if="showError">
      Unable to load preview at this time.
    </danger>
    <spinner v-else />
  </div>
</template>
<script>
import prizm from "@/services/sharedo/prizmService";
import { DEFAULT_TEMPLATE_REPOSITORY } from "@/constants/documentGeneration";
import Spinner from "@/components/common/progress/Spinner.vue";
import Danger from "@/components/common/banners/Danger.vue";

const loadPreview = async function () {
  this.logDebug("Loading preview for legacy content block.", {
    contentBlock: this.contentBlock,
  });

  try {
    this.showError = false;

    var response = await prizm.getViewingSession(
      this.contentBlock.systemName,
      this.contentBlock.templateRepository || DEFAULT_TEMPLATE_REPOSITORY
    );

    this.logInfo("Obtained viewing session from Prizm.", response);

    this.viewingSessionId = response.id;

    this.pageAttibutes = await prizm.getPageAttributes(
      this.viewingSessionId,
      0
    );
    this.logInfo("Obtained page attributes from Prizm.", this.pageAttibutes);

    const contentType = this.pageAttibutes.contentType
      .split(",")
      .find((type) => type !== "svg");

    this.imgSrc = await prizm.getPageImage(
      this.viewingSessionId,
      0,
      0.2,
      contentType
    );

    this.logInfo("Obtained document preview from prizm.", {
      imgSrc: this.imgSrc,
    });
  } catch (error) {
    this.logError("Error loading content block preview from Prizm.", { error });
    this.showError = true;
    throw error;
  }
};

export default {
  components: { Spinner, Danger },
  props: {
    contentBlock: {
      required: true,
    },
  },
  data: function () {
    return {
      viewingSessionId: "",
      pageAttibutes: null,
      imgSrc: "",
      showError: false,
    };
  },
  mounted: loadPreview,
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.legacy-preview {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  & > img {
    border: 1px solid $gray-500;
  }
}
</style>